import { render, staticRenderFns } from "./StampList.vue?vue&type=template&id=2150fbec&scoped=true&"
import script from "./StampList.vue?vue&type=script&lang=ts&"
export * from "./StampList.vue?vue&type=script&lang=ts&"
import style0 from "./StampList.vue?vue&type=style&index=0&id=2150fbec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150fbec",
  null
  
)

export default component.exports